<template>
  <v-app>
    <v-navigation-drawer
        v-model="drawer"
        absolute
        fixed
        app>
      <v-list>
        <v-list-item v-for="item in menuList" :key="item.key"
                     @click="menuEvent(item)">
          <v-list-item-content>
            <v-list-item-title>{{item.label}}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <v-app-bar app fixed dark :color="Theme.PINK">
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title>優視達官網管理系統 v{{ getVersion }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <span class="title">{{getUserInfo.name}}</span>
    </v-app-bar>
    <v-main class="overflow-main">
      <router-view></router-view>
    </v-main>

    <alert-view/>
  </v-app>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import NoticeManager from '@/utils/notice_manager';
import AlertView from "@/components/AlertView";
import * as Constants from '@/utils/constants';
import common from "@/mixins/common";
export default {
  name: "NavigationView",
  components: {AlertView},
  mixins: [common],
  comments:{
    AlertView,
  },
  data(){
    return {
      drawer: false,
    };
  },
  created() {
    NoticeManager.addObserver('login_user', (user) => {
      console.log(`user status ${JSON.stringify(user)}`);
      this.checkUserStatus();
    });
    NoticeManager.notifyObservers('login_user');
  },
  computed: {
    ...mapGetters(['getUserInfo']),
    getVersion(){
      return Constants.APP_VERSION;
    },
    menuList() {
      const menuList = [
        {key: 'home', path: '/admin/index', label: '圖片設定'},
        {key: 'product', path: '/admin/product', label: '商品資料管理'},
        {key: 'counter', path: '/admin/counter', label: '櫃位資料管理'},
        {key: 'news', path: '/admin/news', label: '最新消息管理'},
        {key: 'store', path: '/admin/store', label: '門市資料管理'},
        {key: 'about', path: '/admin/about', label: '品牌故事管理'},
        {key: 'sale', path: '/admin/sale', label: '促銷頁面管理'},
        {key: 'contract', path: '/admin/contract', label: '合約管理'},
        {key: 'watsons', path: '/admin/watsons', label: '屈臣氏管理'},
        {key: 'file', path: '/admin/files', label: '圖檔管理'},
        {key: 'logout', path: '/login', label: '登出'},
      ];
      return menuList;
    },
  },
  methods:{
    ...mapActions(['logout', 'fetchUserInfo', 'configUserInfo']),
    async checkUserStatus(){
      const token = localStorage.getItem('I_USER_TOKEN');
      console.log(`token == ${token}`);
      if (token) {
        const response = await this.fetchUserInfo({ token });
        console.log(`response == ${JSON.stringify(response.data)}`);
        if (response.data && response.data.code === 0) {
          const result = response.data.body;
          console.log(`user == ${JSON.stringify(result)}`);
          result.token = token;
          await this.configUserInfo(result);
        } else {
          this.logout();
          await this.$router.push('/login');
        }
      } else {
        this.logout();
        await this.$router.push('/login');
      }
    },
    menuEvent(menu){
      if (this.$router.currentRoute.path.indexOf(menu.path) === -1){
        if (menu.key === 'logout'){
          this.logout();
          this.$router.push('/login');
        } else {
          this.$router.push(menu.path);
        }
      }
    }
  }
}
</script>

<style scoped>

</style>
